import type { CommonDomainType } from 'common/types'

import { SurveyChoiceGroupItems, SurveyType } from '../types'
import type { CoordinatesType, CoordsTemplate } from './types'

export type CoordinateName = 'X' | 'Y'

export const DOMAIN_TIME_ID: CommonDomainType = 'TWT'
export const unknownFileName = 'Unknown file'

export enum CoordinateSelectionOption {
  Auto = 'Авто',
  Manual = 'Определять вручную',
}

export const coordinateSelectionRules = [
  CoordinateSelectionOption.Auto,
  CoordinateSelectionOption.Manual,
]

export const coordsTemplates: CoordsTemplate[] = [
  {
    xOffset: 73,
    yOffset: 77,
  },
  {
    xOffset: 181,
    yOffset: 185,
  },
]

export const coordinates: CoordinatesType[] = [
  { name: 'X', values: [{ label: '73' }, { label: '181' }], coordName: 'xOffset' },
  {
    name: 'Y',
    values: [{ label: '77' }, { label: '185' }],
    coordName: 'yOffset',
  },
]
export const itemsSurveyGroup = [SurveyType.TwoD, SurveyType.ThreeD]

export const surveyChoiceGroupItems = [
  { name: SurveyChoiceGroupItems.New },
  { name: SurveyChoiceGroupItems.Existent },
]
